module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAALCAYAAAByF90EAAAAAXNSR0IArs4c6QAAAMZJREFUKBWV0bEOAUEQBuCZOaGT8BQKImotnU7tJc57XK/wCDqlVi0Sz0FypbDjfrJyzu0sm1yu+f9v5vaIIucyTEd4IjFiKwCAb7RDRhs06RyzQygfhDyiql2UmflsYbVQGSmAK6ACbFrYF1RFhGkOyCltLOwDqkPap2wLKO+nMwt7QxYCCMfCntAvyIsKY5wPlj3ndI+/g4vFnfjP8eXqu7qZCI/F3d3iHwQoBmEgBqMLQyhprVl4lQhPY5uUN0MWHXRhPAD0oahnDXTHgQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/img/costumers/Amdocs/path.png
// module id = okDI
// module chunks = 0